import { useState } from "react";
import { Link } from "react-router-dom";
import { Empty, fmt, pct } from "./kit";

const LEADS = [["Points", "ppg"], ["Rebounds", "rpg"], ["Assists", "apg"], ["Steals", "spg"], ["Blocks", "bpg"], ["Efficiency", "eff"]];
const COLS = [["GP", "gp"], ["PPG", "ppg"], ["RPG", "rpg"], ["APG", "apg"], ["SPG", "spg"], ["BPG", "bpg"], ["FG%", "fg_pct", true], ["3P%", "fg3_pct", true], ["FT%", "ft_pct", true], ["TS%", "ts_pct", true], ["AST/TO", "ast_to"], ["EFF", "eff"]];

export function TeamLeaders({ rows }) {
  const [sort, setSort] = useState("ppg");
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return <Empty title="No stats yet" text="Leaders appear once games are logged." />;
  const sorted = [...list].sort((a, b) => (b[sort] ?? -1) - (a[sort] ?? -1));
  return (
    <div className="space-y-6" data-testid="team-leaders">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
        {LEADS.map(([label, k]) => {
          const top = [...list].sort((a, b) => (b[k] ?? -1) - (a[k] ?? -1))[0];
          return (
            <div key={k} data-testid={`leader-${k}`} className="rounded-xl border border-[#1E293B] bg-[#162032] p-4">
              <p className="font-mono-gd text-[11px] uppercase tracking-[0.2em] text-slate-400">{label}</p>
              <p className="font-mono-gd text-3xl font-bold text-[#39FF14]">{fmt(top?.[k])}</p>
              {top?.player_id ? <Link to={`/coach/players/${top.player_id}`} data-testid={`leader-${k}-link`} className="block truncate text-sm text-white hover:text-[#39FF14]">{top.name}</Link> : <p className="truncate text-sm text-white">—</p>}
            </div>
          );
        })}
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#1E293B]">
        <table className="w-full min-w-[820px] text-left text-sm" data-testid="team-stats-table">
          <thead className="bg-[#162032]">
            <tr>
              <th className="px-3 py-2 font-mono-gd text-[11px] uppercase tracking-wider text-slate-400">Player</th>
              {COLS.map(([l, k]) => (
                <th key={k} className="px-3 py-2">
                  <button data-testid={`sort-${k}`} onClick={() => setSort(k)} className={`font-mono-gd text-[11px] uppercase tracking-wider ${sort === k ? "text-[#39FF14]" : "text-slate-400 hover:text-white"}`}>{l}</button>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.map((r) => (
              <tr key={r.player_id} className="border-t border-[#1E293B] font-mono-gd text-slate-200 hover:bg-[#162032]/60">
                <td className="px-3 py-2 font-sans"><Link to={`/coach/players/${r.player_id}`} className="text-white hover:text-[#39FF14]">#{r.jersey ?? "–"} {r.name}</Link></td>
                {COLS.map(([, k, isPct]) => <td key={k} className={`px-3 py-2 ${sort === k ? "text-[#39FF14]" : ""}`}>{isPct ? pct(r[k]) : fmt(r[k])}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
